import { ConfirmDialog } from '@/components/modals/ConfirmDialog'
import { buildDiscardOrderConfirmCopy } from '@/components/modals/discardOrderConfirmCopy'

export interface DiscardOrderConfirmDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void | Promise<void>
  isSubmitting?: boolean
  patientName: string
  patientMrn: string
  /** When discarder ≠ draft owner (e.g. a colleague's draft opened from the worklist). */
  draftOwnerDisplayName?: string | null
  draftUpdatedAt?: string | null
  currentUserId?: string | null
  draftOwnerUserId?: string | null
  /** When false, confirm stays disabled until owner metadata is ready (§5.5). */
  confirmReady?: boolean
}

export function DiscardOrderConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  isSubmitting = false,
  patientName,
  patientMrn,
  draftOwnerDisplayName,
  draftUpdatedAt,
  currentUserId,
  draftOwnerUserId,
  confirmReady = true,
}: DiscardOrderConfirmDialogProps) {
  const { title, description } = buildDiscardOrderConfirmCopy({
    patientName,
    patientMrn,
    draftOwnerDisplayName,
    draftUpdatedAt,
    currentUserId,
    draftOwnerUserId,
  })

  return (
    <ConfirmDialog
      isOpen={isOpen}
      onClose={onClose}
      onConfirm={onConfirm}
      title={title}
      description={description}
      confirmLabel="Discard Order"
      cancelLabel="Keep order"
      submittingLabel="Discarding…"
      isSubmitting={isSubmitting}
      confirmDisabled={!confirmReady}
      confirmPendingLabel="Loading…"
    />
  )
}
